import { forwardRef, type InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, error, className = "", id, ...rest },
  ref
) {
  return (
    <label className="field">
      {label ? <span className="field-label">{label}</span> : null}
      <input
        ref={ref}
        id={id}
        className={`field-input ${error ? "is-error" : ""} ${className}`.trim()}
        {...rest}
      />
      {error ? <span className="field-error">{error}</span> : null}
    </label>
  );
});
